import React from "react";
import {FaApple, FaExclamation, FaFirefoxBrowser, FaGlobe, FaUser} from "react-icons/fa";
import {FaTrash} from "react-icons/fa";
import banner from "../img/redirectBanner.jpeg";
import DownApps from "./HomePage/Components/DownApps";
import {Button, Col, Container} from "react-bootstrap";
import DividerCustom from "../components/Generic/DividerCustom";
import {Env} from "../helpers/Env";
import {Images} from "../helpers/Images";
import {FaWebflow} from "react-icons/fa6";

const RedirectGEPage = () => {
    return (
        <div className="d-flex justify-content-center  my-5" style={{minHeight: 600,}}>
            <div className={'col-12 col-lg-12'}
                 style={{display: "flex", flexFlow: 'column', justifyContent: 'center', alignItems: 'center'}}>

                <div>
                    <img src={banner} style={{borderRadius: "15%", maxWidth: 500}}/>
                </div>


                <div className='my-3 mt-5'>
                    <div>
                        <Col xs={12} className='d-flex justify-content-center'>
                            <h2 className='text-primary'>
                                Acessar sua conta é fácil:
                            </h2>
                        </Col>

                        <DividerCustom/>

                        <div className='d-flex justify-content-center text-center'>
                        <Col xs={12} md={8} lg={7}>
                                <h5 style={{lineHeight: 1.8}} className='my-2 text-muted fw-light'>Basta entrar no site ou baixar o app e depois utilizar seu CPF e senha do Geração Serviço!
                                </h5>
                            </Col>
                        </div>
                    </div>

                    <Container fluid={'lg'}>
                        <div className='d-flex flex-wrap justify-content-center'>
                            <Col xs={12} md={6} lg={5} xxl={4} className='p-2 text-center'>
                                <div
                                    className='d-flex flex-column justify-content-between bg-white shadow-lg p-2 rounded-2 h-100'>

                                    <Col xs={8} className='mx-auto'>
                                        <img className='mb-2 w-100' src={Images.download_app_peoples.hire_people}
                                             alt='hire'/>
                                    </Col>
                                    <div className='p-2 h-100'>
                                        <div className='p-0 p-lg-1 h-100'>
                                            <h4 className='text-bg-primary text-white p-2 rounded-2 shadow-sm de-flex flex-1 h-100 mb-0'>
                                                Quero encontrar um profissional ou produto!
                                            </h4>
                                        </div>

                                    </div>

                                    <div className='d-flex flex-wrap justify-content-center p-2'>
                                        <Col xs={12} md={6} className='p-1'>
                                            <Button variant='dark' className='w-100'
                                                    onClick={() => window.redirectWorker("https://play.google.com/store/apps/details?id=br.com.bluetrix.rondoniatemtudo.hirer")}>
                                                <div className='de-flex gap-2'>
                                                    <img height={20} src={Images.gplay_icon} alt='icon play store'/>
                                                    <span className='text-start'>
                                            <span className='fw-lighter fs-8'>Disponível no</span> <strong
                                                        className='ms-1 d-inline d-md-block'> Google Play </strong>
                                        </span>
                                                </div>
                                            </Button>
                                        </Col>

                                        <Col xs={12} md={6} className='p-1'>
                                            <Button variant={"dark"} className='w-100'
                                                    onClick={() => window.redirectWorker("https://apps.apple.com/app/rondônia-tem-tudo/id6504834255")}>
                                                <div className='de-flex gap-2'>
                                                    <FaApple size={24}/>
                                                    <span className='text-start'>
                                            <span className='fw-lighter fs-8'>Disponível na</span> <strong
                                                        className='ms-1 d-inline d-md-block'>App Store </strong>
                                        </span>
                                                </div>
                                            </Button>
                                        </Col>

                                        <Col xs={12}  className='p-1'>
                                            <Button variant={"dark"} className='w-100'
                                                    onClick={() => window.redirectWorker("https://rondoniatemtudo.ro.gov.br")}>
                                                <div className='de-flex gap-2'>
                                                    <FaGlobe
                                                        size={24}/>
                                                    <span className='text-start'>
                                            <span className='fw-lighter fs-8'> </span><strong
                                                        className='ms-1 d-inline d-md-block'>Acessar Site</strong>
                                        </span>
                                                </div>
                                            </Button>
                                        </Col>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={5} xxl={4} className='p-2 text-center'>
                                <div
                                    className='d-flex flex-column justify-content-between bg-white shadow-lg rounded-2 p-2 h-100'>

                                    <Col xs={8} className='mx-auto'>
                                        <img className='mb-2 w-100' src={Images.download_app_peoples.work_people}
                                             alt='pro'/>
                                    </Col>

                                    <div className='p-2 h-100'>
                                        <div className='p-0 p-lg-1 h-100'>
                                            <h4 className='text-bg-success text-white p-2 rounded-2 shadow-sm de-flex flex-1 h-100 mb-0'> Quero divulgar meu serviço e/ou meu estabelecimento </h4>
                                        </div>
                                    </div>

                                    <div className='d-flex flex-wrap align-items-center p-2'>
                                        <Col xs={12} md={6} className='p-1'>
                                            <Button variant='dark' className='w-100'
                                                    onClick={() => window.redirectWorker("https://play.google.com/store/apps/details?id=br.com.bluetrix.rondoniatemtudo")}>
                                                <div className='de-flex gap-2'>
                                                    <img height={20} src={Images.gplay_icon} alt='icon play store'/>
                                                    <span className='text-start'>
                                            <span className='fw-lighter fs-8'>Disponível no</span><strong
                                                        className='ms-1 d-inline d-md-block'> Google Play </strong>
                                        </span>
                                                </div>
                                            </Button>
                                        </Col>

                                        <Col xs={12} md={6} className='p-1'>
                                            <Button variant={"dark"} className='w-100'
                                                    onClick={() => window.redirectWorker("https://apps.apple.com/app/rondônia-tem-tudo-parceiros/id6504413643")}>
                                                <div className='de-flex gap-2'>
                                                    <FaApple size={24}/>
                                                    <span className='text-start'>
                                            <span className='fw-lighter fs-8'>Disponível na</span><strong
                                                        className='ms-1 d-inline d-md-block'>App Store </strong>
                                        </span>
                                                </div>
                                            </Button>
                                        </Col>

                                        <Col xs={12}  className='p-1'>
                                            <Button variant={"dark"} className='w-100'
                                                    onClick={() => window.redirectWorker("https://rondoniatemtudo.ro.gov.br")}>
                                                <div className='de-flex gap-2'>
                                                    <FaGlobe
                                                        size={24}/>
                                                    <span className='text-start'>
                                            <span className='fw-lighter fs-8'> </span><strong
                                                        className='ms-1 d-inline d-md-block'>Acessar Site</strong>
                                        </span>
                                                </div>
                                            </Button>
                                        </Col>
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </Container>
                </div>

            </div>
        </div>
    )
}
export default RedirectGEPage
